//LIPSYNC_MODELS = lipsync models with type = "normal"

export enum TWIN_STUDIO_TABS {
  LIPSYNC_MODELS = "High Quality Twins",
  ZERO_SHOT = "Express Twins",
  SYNTHETICS = "Image Based Twins",
}
